<template>
  <div>
    <div
      :id="mapId"
      :style="{ height: height }"
      class="map"
      :class="tdt ? 'tdt' : ''"
    ></div>
    <div class="base_map-zoom">当前缩放等级: {{ zoom }}</div>

    <nMapLayer
      v-if="map"
      class="car-collapse"
      style="background-color: white;"
      :option="layerOpts"
      :map="map"
      :region-id="projectInfo.regionId"
    ></nMapLayer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { map_theme } from "../options/theme";
import { getBoundary, drawBoundary } from "../utils/util";
import { loadTdt } from "../utils/loadTdt";
import { getBorder } from "@/api/api";
export default {
  data() {
    return {
      map: null,
      layerOpts: {
        show: true,
        gf: false,
        poi: true,
        custom: false,
        region: false,
        remoteSense: false
      },
      tdt: false,
      polygon: "",
      borderData: [],
      zoom: null
    };
  },
  mounted() {
    this.initMap();
  },
  props: ["height", "mapId", "show_map_type", "showOldborder"],
  watch: {
    showOldborder() {
      if (this.showOldborder) {
        this.map.removeOverlay(_ply);
        this.drawBorder();
      } else {
        this.map.removeOverlay(this.polygon);
        drawBoundary(this.map, this.centerCity);
      }
    }
  },
  computed: {
    ...mapState(["projectInfo"]),
    centerCity() {
      if (this.projectInfo.name) {
        return this.projectInfo.name;
      } else {
        return "北京";
      }
    }
  },
  methods: {
    initMap() {
      this.tdt = this.$route.query.map;
      var self = this;
      var map = new BMap.Map(this.mapId, {
        enableMapClick: false,
        minZoom: 1
      });
      this.zoom = 10;
      if (this.centerCity === '济南市' || this.centerCity === '济南') {
        var p = new BMap.Point(117.074656, 36.774157);
        map.centerAndZoom(p, this.zoom);
      }else {
        map.centerAndZoom(this.centerCity, 10);
      }
      if (this.$is_dock_env) {
        loadTdt(map, "white");
      } else {
        if (!this.tdt) {
          drawBoundary(map, this.centerCity);
          // getBoundary(map, '济南')
          // map.setMapStyle(map_theme)
        } else {
          loadTdt(map, "white");
          // map.setMapStyle('normal')
        }
      }
      
      map.addEventListener("zoomend", () => {
        const zoom = this.map.getZoom();
        this.zoom = zoom;
      });
      map.addEventListener("click", x => {
        console.log(x.point);
      });
      map.enableScrollWheelZoom(true);
      map.enableDragging();
      map.enableKeyboard();
      if (this.show_map_type != 0) {
        var mapType1 = new BMap.MapTypeControl({
          mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP],
          anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
          offset: new BMap.Size(5, 30)
        });
        map.addControl(mapType1); //2D图，卫星图
      }
      var top_left_control = new BMap.ScaleControl({
        anchor: BMAP_ANCHOR_BOTTOM_LEFT
      });
      map.addControl(top_left_control);
      var myDis = new BMapLibb.DistanceTool(map);
      var contextMenu = new BMap.ContextMenu(); //创建右键对象
      var txtMenuItem = [
        {
          text: "折线测距",
          callback: function() {
            myDis.open();
          }
        }
      ];
      for (var i = 0; i < txtMenuItem.length; i++) {
        contextMenu.addItem(
          new BMap.MenuItem(txtMenuItem[i].text, txtMenuItem[i].callback, 100)
        );
        if (i == 1 || i == 3) {
          contextMenu.addSeparator();
        }
      }
      map.addContextMenu(contextMenu);
      map.setCurrentCity(this.centerCity); //由于有3D图，需要设置城市哦
      this.$emit("map", map);
      window.map = map;
      this.map = map;
    },
    drawBorder() {
      if (this.borderData.length) {
        let arr = [];
        for (let item of this.borderData) {
          let gcj = coordtransform.wgs84togcj02(item.lng, item.lat);
          let bd = coordtransform.gcj02tobd09(gcj[0], gcj[1]);
          arr.push(new BMap.Point(bd[0], bd[1]));
        }
        this.polygon = new BMap.Polygon(arr, {
          strokeColor: "red",
          strokeWeight: 2,
          strokeOpacity: 1,
          fillColor: ""
        });
        this.map.addOverlay(this.polygon);
        return;
      }
      getBorder().then(res => {
        this.borderData = res.data[0];
        let arr = [];
        for (let item of res.data[0]) {
          let gcj = coordtransform.wgs84togcj02(item.lng, item.lat);
          let bd = coordtransform.gcj02tobd09(gcj[0], gcj[1]);
          arr.push(new BMap.Point(bd[0], bd[1]));
        }
        this.polygon = new BMap.Polygon(arr, {
          strokeColor: "red",
          strokeWeight: 2,
          strokeOpacity: 1,
          fillColor: ""
        });
        this.map.addOverlay(this.polygon);
      });
    }
  }
};
</script>
<style scoped>
.tdt {
  background: white !important;
}
.base_map-zoom {
  position: absolute;

  bottom: 7px;
  left: 130px;
  z-index: 10;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/BaseMap.vue